import { memo } from "react";
import { Sidebar } from "primereact/sidebar";
import MobileTopBar from "./topbar/mobile/MobileTopBar";
import MobileSidebarHeader from "./topbar/mobile/MobileSidebarHeader";
import MobileAccountSection from "./topbar/mobile/MobileAccountSection";
import MobileWarehouseSection from "./topbar/mobile/MobileWarehouseSection";
import MobileNavMenu from "./topbar/mobile/MobileNavMenu";
import useMobilePanelMenu from "./topbar/mobile/useMobilePanelMenu";
import { useAuthContext } from "../../app/providers/contextIndex";

const LandingMobile = memo(({
  logo,
  cartCount,
  isCartLoading,
  shouldShowCollections,
  menuStructure,
  isMobileMenuOpen,
  closeMobileMenu,
  setIsMobileMenuOpen,
  warehouseOptions,
  selectedAlmacen,
  setSelectedAlmacen,
  appUser,
  handleOpenLogin,
  handleLogout,
  handleAllProductsNavigation,
  handleCatalogNavigation,
  searchTerm,
  setSearchTerm,
  handleSearchSubmit,
  handleSearchKeyDown,
  handleVoiceInput,
  isListening,
  isVoiceSupported,
  searchPlaceholder,
  disabled = false,
}) => {
  const { appCanal } = useAuthContext();

  const panelMenuItems = useMobilePanelMenu({
    menuStructure,
    handleAllProductsNavigation,
    handleCatalogNavigation,
  });

  return (
    <>
      <MobileTopBar
        logo={logo}
        cartCount={cartCount}
        isCartLoading={isCartLoading}
        shouldShowCollections={shouldShowCollections}
        menuStructure={menuStructure}
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        appUser={appUser}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        handleSearchSubmit={handleSearchSubmit}
        handleSearchKeyDown={handleSearchKeyDown}
        handleVoiceInput={handleVoiceInput}
        isListening={isListening}
        isVoiceSupported={isVoiceSupported}
        searchPlaceholder={searchPlaceholder}
      />

      <Sidebar
        visible={isMobileMenuOpen}
        onHide={closeMobileMenu}
        position="right"
        showCloseIcon={false}
        style={{ background: "#fff", border: "none", minWidth: 300 }}
      >
        <MobileSidebarHeader appCanal={appCanal}/>

        <MobileAccountSection
          appUser={appUser}
          closeMobileMenu={closeMobileMenu}
          handleOpenLogin={handleOpenLogin}
          handleLogout={handleLogout}
        />

        <MobileWarehouseSection
          warehouseOptions={warehouseOptions}
          selectedAlmacen={selectedAlmacen}
          setSelectedAlmacen={setSelectedAlmacen}
          disabled={disabled}
        />

        {shouldShowCollections ? (
          <MobileNavMenu panelMenuItems={panelMenuItems} />
        ) : null}
      </Sidebar>
    </>
  );
});

export default LandingMobile;